class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
    this.hoverEnabled = false;
    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.onMouseEnterHandler = this.onMouseEnter.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeave.bind(this);

    if (this.hoverMedia.matches) {
      this.enableHover();
    }

    this.hoverMedia.addEventListener('change', (event) => {
      if (event.matches) {
        this.enableHover();
      } else {
        this.disableHover();
        this.close();
      }
    });
  }

  enableHover() {
    if (this.hoverEnabled) return;
    this.addEventListener('mouseenter', this.onMouseEnterHandler);
    this.addEventListener('mouseleave', this.onMouseLeaveHandler);
    this.hoverEnabled = true;
  }

  disableHover() {
    if (!this.hoverEnabled) return;
    this.removeEventListener('mouseenter', this.onMouseEnterHandler);
    this.removeEventListener('mouseleave', this.onMouseLeaveHandler);
    this.hoverEnabled = false;
  }

  onMouseEnter() {
    if (!this.hoverMedia.matches) return;

    window.clearTimeout(this.hoverCloseTimeout);

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    this.open();
  }

  onMouseLeave() {
    if (!this.hoverMedia.matches) return;

    window.clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = window.setTimeout(() => {
      this.close();
    }, 100);
  }

  open() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.mainDetailsToggle.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  close() {
    window.clearTimeout(this.hoverCloseTimeout);
    super.close();
    if (this.header) this.header.preventHide = false;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
